import React from "react";
import * as ReactDOM from "react-dom";
import _ from "lodash";
import $ from "jquery";

const ACTIVE_CLASS = "project--over-active";
const INACTIVE_CLASS = "project--over-any";
const HOVER_CLASS = "project--hover";

/**
 * A project lives in a project list.
 */
class Project extends React.Component {
  constructor(props) {
    super(props);

    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  /**
   */
  componentDidMount() {
    this.$el = $(ReactDOM.findDOMNode());
  }

  /**
   * Build project link, pass along current category as bucket param if exists.
   * @return {string}
   */
  buildProjectLink() {
    let link = `/portfolio/p/${this.props.path}`;
    if (!_.isEmpty(this.props.category)) {
      link += `?b=${this.props.category}`;
    }
    return link;
  }

  /**
   * Returns thumbnail image path
   * @return string
   */
  getImageUrl() {
    return `/img/portfolio/${this.props.path}/main.jpg`;
  }

  /**
   * 4 templates per group
   * @return {Number}
   */
  getTemplateId() {
    if (this.props.group == "a") {
      if (this.props.index == 0) {
        return 1;
      }
      return 2;
    }
    if (this.props.index == 1) {
      return 4;
    }
    return 3;
  }

  /**
   * Toggle classes
   */
  onMouseOver() {
    const $project = $(`.project--key-${this.props.path}`);
    $project.addClass(HOVER_CLASS);

    const self = this;
    // set a slight delay in case it's just a quick over and out.
    setTimeout(() => {
      if ($project.hasClass(HOVER_CLASS)) {
        $(".project")
          .not(`.project--key-${self.props.path}`)
          .addClass(INACTIVE_CLASS);
        $project.addClass(ACTIVE_CLASS);
      }
    }, 200);
  }

  /**
   * Toggle class
   */
  onMouseOut() {
    $(".project").removeClass(
      `${INACTIVE_CLASS} ${ACTIVE_CLASS} ${HOVER_CLASS}`
    );
  }

  /**
   */
  render() {
    return (
      <div
        className={`project project--template-${this.getTemplateId()} project--key-${
          this.props.path
        }`}
      >
        <a
          href={this.buildProjectLink()}
          className="project__anchor"
          onMouseOver={this.onMouseOver}
          onMouseOut={this.onMouseOut}
        >
          <div
            className="project__img"
            style={{ backgroundImage: `url(${this.getImageUrl()})` }}
          />
          <label
            className="project__title"
            title={`${this.props.desc} Click or touch to view details.`}
          >
            {this.props.name}
          </label>
          <div className={`project__date ${this.props.years.includes('current') ? 'project__date--extended' : ''}`}>{this.props.years}</div>
        </a>
      </div>
    );
  }
}

export default Project;
